<template>
  <div class="profile-chip mb-2" :class="{ 'profile-chip--mini': mini }" v-if="!$auth.loading && $auth.isAuthenticated">
    <v-avatar size="40">
      <v-img :src="$auth.user.picture"></v-img>
    </v-avatar>
    <div class="profile-chip__text" v-if="!mini">
      <div class="profile-chip__name">{{ $auth.user.name }}</div>
      <div class="profile-chip__email">{{ $auth.user.email }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mini: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.profile-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 12px;
  background-color: var(--color-profile-bg);
  border-radius: var(--radius-lg);
  overflow: hidden;

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  &__name {
    font-family: var(--font-family);
    font-size: var(--font-size-14);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-20);
    color: #1D1B20;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &--mini {
    background-color: transparent;
    padding: 0;
    justify-content: center;
  }

  &__email {
    font-family: var(--font-family);
    font-size: var(--font-size-12);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-16);
    color: #49454E;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>